var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({staticClass:"default-transition",class:{'opacity-0': _vm.hideImage},attrs:{"alt":_vm.alt,"src":_vm.source},on:{"error":_vm.onError,"load":_vm.onLoad}},'img',_vm.imgTagSizeAttributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }